<div class="modal" data-cy="create-checklist-modal" cdkScrollable>
  <header class="modal__header">
    <h2 class="modal__header__title">
      {{ 'Fill out checklist' | translate }}
    </h2>

    <button class="modal__header__close" data-cy="close-button" (click)="close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content create-container" data-cy="create-checklist-content">
    <div class="flex-row">
      <ng-container class="form__container">
        <form class="create-container__form" [formGroup]="formGroup">
          <div class="create-container__header">
            {{ 'Select a project and template in order to fill out a new checklist.' | translate }}
          </div>

          <div class="controls-row">
            <div appFormControlError="project_id" class="control-container form-group py-0 text-ellipsis">
              <div class="control-container__label">
                <span translate>Project</span>
                <span class="control-container__required">*</span>
                <ng-container *ngIf="!isEmployee">
                  <span class="create-label" data-cy="create-project-button" (click)="openCreateProjectModal()">
                    <i class="icon icon-Plus_ico icon-plus"></i>
                    <span translate>Create</span>
                  </span>
                </ng-container>
              </div>

              <app-select
                valueKey="id"
                displayKey="name"
                formControlName="project_id"
                [placeholder]="'Search' | translate"
                [withNone]="false"
                [model]="projectModel"
                [collection]="projectsCollection"
                [optionList]="projectsCollection.items$ | push"
                (refreshCallback)="getProjectsList($event)"
                (selectedValue)="onSelectProject($event)"
                data-cy="project-searchSelect">
                <ng-container *selectOption="let option">
                  <span>{{ option.name }} ({{ option?.display_id }})</span>
                </ng-container>
              </app-select>
            </div>
          </div>

          <div class="controls-row">
            <div appFormControlError="category_id" class="control-container form-group py-0 text-ellipsis">
              <div class="control-container__label">
                <span translate>Category</span>
              </div>

              <app-select
                valueKey="id"
                displayKey="name"
                fieldKey="id"
                [collection]="categoryCollection"
                [optionList]="categoryCollection.items$ | push"
                [model]="categoryModel"
                [withNone]="true"
                (refreshCallback)="getCategoryList($event)"
                (selectedValue)="onSelectedCategory($event)"
                data-cy="category-searchSelect">
              </app-select>
            </div>
          </div>

          <div class="controls-row">
            <div appFormControlError="template_id" class="control-container form-group py-0 text-ellipsis">
              <div class="control-container__label">
                <span translate>Template</span>
                <span class="control-container__required">*</span>
              </div>

              <app-select
                valueKey="id"
                displayKey="name"
                fieldKey="id"
                [collection]="templatesCollection"
                [optionList]="templatesCollection.items$ | push"
                [model]="templateModel"
                [disabled]="formGroup.get('project_id').invalid"
                matTooltip="{{ 'Select Project first' | translate }}"
                [matTooltipDisabled]="!formGroup.get('project_id').invalid"
                [withNone]="false"
                (refreshCallback)="getTemplateList($event)"
                (selectedValue)="onSelectedTemplate($event)"
                data-cy="template-searchSelect">
                <ng-container *selectOption="let option">
                  <span>
                    {{ option.name }}
                    <ng-container *ngIf="option?.doc_number"> ({{ option.doc_number }}) </ng-container>
                  </span>
                </ng-container>
              </app-select>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>

  <div class="modal__actions">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2 uppercase cancel-btn" (click)="close()" data-cy="cancel-button">
        <span translate>Cancel</span>
      </button>

      <btn-loader
        data-cy="submit-button"
        styleClasses="btn__primary"
        [uppercase]="true"
        [buttonLabel]="'NEXT' | translate"
        (applyAction)="submit()"
        [loading]="(checklistItem.loadingCrud$ | async).creating"></btn-loader>
    </div>
  </div>
</div>
